import SqOneTrust from '@square/one-trust';
import { OneTrustConsent, onetrustWindow, ONE_TRUST_ALERT_COOKIE, POST_NEW_ONE_TRUST_INSTANCE } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import Cookie from 'js-cookie';
import { registerDestructor } from '@ember/destroyable';
import { getOneTrustActiveGroups, isEmberHost } from '@square/dashboard-utilities/utils/window';
import { isTesting } from '@square/dashboard-utilities/utils/ember';
const ONE_TRUST_PREFERENCE_CHANGE = 'dashboardOneTrustPreferencesChangedEvent';
function onOneTrustPreferenceChange() {
  updateOneTrustPreferences();
}
function updateOneTrustPreferences(scriptFailedToLoad) {
  // Create a new instance of SqOneTrust every time consent changes
  onetrustWindow.SqOneTrust = new SqOneTrust({
    passSquareGeoToOneTrust: true
  });
  if (scriptFailedToLoad && !cookieIsValid()) {
    // Manually set the consent to nothing but strictly necessary
    onetrustWindow.SqOneTrust.groupConsentHash = {
      [OneTrustConsent.STRICTLY_NECESSARY]: '1',
      [OneTrustConsent.PERFORMANCE]: '0',
      [OneTrustConsent.FUNCTIONAL]: '0',
      [OneTrustConsent.TARGETING]: '0'
    };
  }
  ensureAlertBoxCookieExists();

  // Alert Dashboard and other scripts injected into Dashboard to update themselves with the new consent.
  document.dispatchEvent(new CustomEvent(POST_NEW_ONE_TRUST_INSTANCE));
}
export function initialize(appInstance) {
  if (!isEmberHost()) {
    return;
  }

  // If OnetrustActiveGroups are not set, the OneTrust script didn't run.
  // The script should run synchronously before any of this code executes.
  if (!getOneTrustActiveGroups() && !isTesting()) {
    // Dashboard will fallback to a last-known or minimal-consent state.
    updateOneTrustPreferences(true);
    return;
  }
  updateOneTrustPreferences();
  document.addEventListener(ONE_TRUST_PREFERENCE_CHANGE, onOneTrustPreferenceChange);
  registerDestructor(appInstance, () => {
    document.removeEventListener(ONE_TRUST_PREFERENCE_CHANGE, onOneTrustPreferenceChange);
  });
}

// Check if the OptanonAlertBoxClosed cookie is set to a valid date of less than a year ago.
function cookieIsValid() {
  const alertCookieDate = Cookie.get(ONE_TRUST_ALERT_COOKIE);
  if (!alertCookieDate) {
    // if no alert box cookie is available at all, this merchant was auto-consented
    return true;
  }
  const alertInteractionDate = new Date(alertCookieDate);
  if (Number.isNaN(alertInteractionDate.getDate())) {
    return false;
  }
  const currentDate = new Date();
  const diff = currentDate.getTime() - alertInteractionDate.getTime();
  const yearDiff = diff / (1000 * 60 * 60 * 24 * 365);
  return yearDiff < 1;
}

/**
 * Certain browser extensions such as "I don't care about cookies" try to circumvent OneTrust.
 * They will force the OneTrust modal to hide and set the cookie manually.
 * This causes issues for our hasConsent script triggers as the alert cookie is
 * how we know a merchant has interacted with the modal.
 *
 * This will set that cookie manually to avoid this issue.
 */
function ensureAlertBoxCookieExists() {
  const existingCookie = Cookie.get(ONE_TRUST_ALERT_COOKIE);
  if (existingCookie) {
    return;
  }
  const oneTrustSdkElement = document.getElementById('onetrust-consent-sdk');
  const isHidden = oneTrustSdkElement ? window.getComputedStyle(oneTrustSdkElement).visibility === 'hidden' : false;
  if (isHidden) {
    Cookie.set(ONE_TRUST_ALERT_COOKIE, new Date().toISOString());
  }
}
export default {
  initialize
};